<template>
    <div>
        <section class="section-grey py-3 my-3">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-sm-3">
                        {{ items.length }} resultaten
                    </div>
                    <div class="col-sm-9">
                        <div v-if="activeFilters">
                            <span class="badge badge-secondary m-2" v-for="item in activeFilters" v-if="activeFilters.length">
                                {{ item.title }} <i class="fas fa-times ml-3 cursor-pointer" @click="removeFilter(item.type)"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
            <div class="row">
                <div class="col-sm-3">
                    <h2 class="h3 text-normal mt-5 mb-3">Filters</h2>
                    <div class="form-group mb-2" v-for="filter in filterOptions" :key="filter.name">
                        <label :for="filter.name" class="col-form-label">{{ filter.name }}</label>
                        <select :name="filter.name" :id="filter.name"
                                class="custom-select custom-select-filter" v-model="filter.selected" >
                            <option selected value="">Selecteer een optie</option>
                            <option :value="option" v-for="option in filter.options">{{ option.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div :class="{'show':item.active}" class="card card-toggle cursor-pointer"
                         v-for="(item, index) in items" :key="index" @click="show(item)">
                        <div class="card-body d-flex justify-content-between align-items-center">
                            <div>
                                <p class="meta p-0 text-purple">
                                    {{ item.subtitle }}
                                </p>
                                <h2>{{ item.title }}</h2>
                            </div>
                            <i class="far"
                               :class="{ 'fa-external-link-alt': item.url, 'fa-angle-down': item.tekst }"></i>
                        </div>
                        <transition-slide-toggle>
                            <div class="card-footer" v-if="item.active || item.url" v-html="item.tekst"></div>
                        </transition-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { url } from '../js/mixins/url'

    export default {

        mixins: [url],
        props: {
            perPage: Number,
        },
        data() {
            return {
                rawItems: [],
                filters: [
                    'onderwerpen',
                    'trefwoorden',
                    'gewassen',
                ],
                filterOptions: [],
                urlParams: this.getAllUrlParams(window.location.href )
            }
        },
        created() {

            let that = this;
            this.axios.get('/api/artikelen')
                .then(function (response) {
                    that.rawItems = response.data.items;

                    _.map(that.rawItems, item => {
                        _.assignIn(item, {subtitle: _.join(_.map(item.onderwerpen, 'title'), ', ')})
                    });

                    that.filterOptions = response.data.filters;
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {

                    _.map(that.filterOptions, option => {

                        let param = that.urlParams[_.toLower(_.replace(option.name, ' ', '_'))];

                        if(param && _.parseInt(param)){
                            option.selected= _.find(option.options, {id: _.parseInt(param)});
                        } else {
                            option.selected= '';
                        }

                    });

                });
        },
        computed: {
            activeFilters() {
                let items = [];
                _.map(this.filterOptions, item => {
                    if (item.selected) {
                        items.push(_.assignIn(item.selected, {type: item.name}))
                    }
                });
                return items;
            },
            items() {
                if (this.activeFilters.length) {
                    let items = [];
                    _.map(this.rawItems, item => {
                        _.map(_.without(_.map(this.filterOptions, 'selected'), ''), filter => {
                            if (_.some(item[_.toLower(_.replace(filter.type, ' ', '_'))], {'id': filter.id})) {
                                items.push(item);
                            }
                        })

                    });

                    return _.uniqWith(items, _.isEqual);

                } else {
                    return this.rawItems;
                }
            }
        },
        methods: {
            show(item) {
                if (item.url) {
                    window.open(item.url, '_blank');
                } else {
                    item.active = !item.active
                }

            },
            removeFilter(type) {
                _.find(this.filterOptions, {name: type}).selected = '';
            }

        }
    }
</script>